<template>
  <div class="join-form">
    <div class="join-form--left">
      <WelcomeSection />
    </div>
    <div class="join-form--right">
      <div class="join-form--step step-one nice-form">
          <div class="step-one--intro">
            <h2>Get started below</h2>
            <p>Start your membership journey by creating your account with a few easy steps.</p>
          </div>
          <div class="step-one--form">
            <p>What state do you work or study in?</p>
            <div class="states-wrapper">
              <div v-for="s in states" :key="s.key" class="state-item"
                :class="{'selected': form.state == s.key}" @click.prevent="updateState(s.key)">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-check fa-check"><path d="M20 6 9 17l-5-5"/></svg>
                <component :is="s.key" class="stateMap"/>
                <h4>{{ s.label }}</h4>
              </div>
            </div>
          </div>
          <div style="display: none;" class="step-one--promo">
            <!-- <p class="info-text">Please note: If you have an promote code please input below</p> -->
            <p>If you have a promo code, please enter it below</p>
            <custom-field
              label="Promo code"
              maxlength="20"
              v-model="data.promoteCode"
            />

            <div v-if="data.promoteCode && data.promoteCode === 'AMANSW25'" class="valid-code">
              <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="currentColor"><path d="m424-296 282-282-56-56-226 226-114-114-56 56 170 170Zm56 216q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z"/></svg>
              <p>Valid code</p>
            </div>

            <!-- <input type="text" class="input input-nm" placeholder="Promote Code (if applicable)" v-model="data.promoteCode"/>
            <p v-if="data.promoteCode && data.promoteCode === 'AMANSW25'">Correct code</p>
            <p v-else>Incorrect code or input box is empty, please click next to complete your join process</p> -->
          </div>
          <div class="step-footer">
            <span>Already a member? <a href="/sign-in">Sign in</a></span>
            <button @click.prevent="next"  class="button button-blue button-nm" :disabled="!form.state">Next</button>
          </div>
      </div>
    </div>
  </div>
</template>
<script>
  import WelcomeSection from './WelcomeSection';
  import { ACT, NT, QLD, SA, NSW, TAS, VIC, WA } from '../icons';
  import customField from "../forms/customField";
  export default {
    name:'step-one',
    props: ['form', 'step', 'options'],
    components: {
      WelcomeSection,
      ACT, NT, QLD, SA, NSW, TAS, VIC, WA,
      customField
    },
    data() {
      return {
        data: null,
        states: [
          { key: 'QLD', label: 'Queensland' },
          { key: 'NSW', label: 'New South Wales' },
          { key: 'ACT', label: 'Australian Capital Territory' },
          { key: 'WA', label: 'Western Australia' },
          { key: 'SA', label: 'South Australia' },
          { key: 'VIC', label: 'Victoria' },
          { key: 'TAS', label: 'Tasmania' },
          { key: 'NT', label: 'Northern Territory' },
        ]
      }
    },
    methods: {
      updateState(state) {
        this.data.state = state;
        this.$emit('update:form', this.data);
      },
      next() {
        if (this.form.state === 'NSW') {
          window.location.href = 'https://australianmedicalassociation.com.au/maintenance';
          return;
        }
        const states = Array.isArray(this.options.enabledStates) ? this.options.enabledStates: [];

        if (states.includes(this.form.state)) {
          this.$emit('update:step', 2);
        } else {
          this.$emit('update:step', -1);
        }
      }
    },
    mounted() {
      this.data = this.form;
    }
  }
</script>
